import { Datepicker } from "vanillajs-datepicker";
import "vanillajs-datepicker/css/datepicker-bs5.css";

export function initializeDatepicker(element, options = {}) {
  return new Datepicker(element, {
        buttonClass: "btn",
        autohide: true,
        clearButton: true,
        todayHighlight: true,
        ...options,
  });
}

export const months = [
    { name: "january", value: "January"},
    { name: "february", value: "February"  },
    { name: "march", value: "March" },
    { name: "april", value: "April" },
    { name: "may", value: "May" },
    { name: "june", value: "June" },
    { name: "july", value: "July" },
    { name: "august", value: "August" },
    { name: "September", value: "September" },
    { name: "october", value: "October" },
    { name: "november", value: "November" },
    { name: "december", value: "December" },
]; 

export const amount_types = [
    { name: "donations", value: "Donations" },
    { name: "investment_income", value: "Investment/Interest Income" },
    { name: "fees", value: "Fees" },
    { name: "fines", value: "Fines" },
    { name: "special_fundraising", value: "Special Fundraising" },
    { name: "party_paraphernalia", value: "Sale of Party Paraphernalia" },
    { name: "others", value: "Others (Specify)" },
];

export const expenditure_types = [
    { name: "staff_cost", value: "Party Staff Cost" },
    { name: "office_cost", value: "Office Cost" },
    { name: "transportation_communication", value: "Transportation & Communication" },
    { name: "campaign_expenses", value: "Campaign Expenses" },
    { name: "legal_fees", value: "Legal & Audit Fees" },
    { name: "others", value: "Others (Specify)" },
];


